import { PageHeader } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { IEpisodeCategory } from '@common/interfaces/episodeCategory';
import type { IReduxState } from '@frontend/configureStore';
import { ManagerAuthorization } from '@common/enums';
import { EpisodeCategoryButtonRow } from '@frontend/components/elements/EpisodeCategoryButtonRow';
import { getSelectedLanguage } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import { usePersonalSettings } from '../PersonalSettingsContext';
import { ServiceEmailNotificationSettingsEpisode } from './ServiceEmailNotificationSettingsEpisode';

export function ServiceEmailNotificationSettings() {
    const translate = getSelectedLanguage();
    const { isReadOnly } = usePersonalSettings();
    const { employmentId } = useParams() as { employmentId: string };
    const isManager = useSelector((state: IReduxState) => state.authentication.isManager);
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);
    const [selectedCategory, setSelectedCategory] = useState<IEpisodeCategory>();

    if (isManager && selectedEmploymentId !== employmentId) {
        assertHasAuthorization(ManagerAuthorization.employmentSettingsRead);
    }

    return (
        <>
            <PageHeader title={translate.personalSettings.emailNotifications} />

            <EpisodeCategoryButtonRow
                employmentId={employmentId}
                onCategoryClick={(category) => setSelectedCategory(category)}
            />

            {selectedCategory && (
                <ServiceEmailNotificationSettingsEpisode
                    employmentId={employmentId}
                    episodeCategory={selectedCategory.name}
                    readOnly={isReadOnly}
                />
            )}
        </>
    );
}
